module.exports = __webpack_public_path__ + "static/media/zscalar-dark.8fcd44b8.svg";